<template>
  <a-select
    :allowClear="allowClear"
    :show-search="showSearch"
    :placeholder="placeholder"
    option-filter-prop="children"
    :style="styleModule"
    :filter-option="filterOption"
    @focus="handleFocus"
    @blur="handleBlur"
    @change="handleChange"
  >
    <a-select-option v-for="(item,index) in list" :key="index" :value="item.objectId">
      {{ item[val] }}
    </a-select-option>
  </a-select>
</template>

<script>

export default {
  props: {
    placeholder: {
      type: String,
      default: '请选择'
    },
    allowClear: {
      type: Boolean,
      default: false
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    styleModule: {
      type: Object,
      default: () => {
        return {
          width: '85px'
        }
      }
    },
    list: { // 数组
      type: Array,
      default: () => {
        return []
      }
    },
    val: { // 展示的字段  例如：item.name item.text item.title...
      type: String,
      default: 'name'
    },
    value: { // 选中的值
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (v) {
        console.log(v)
        // v-model接收input事件的值来更新value
        this.$emit('update:value', v)
      }
    }
  },
  // 修改父组件传入的value
  methods: {
    handleChange (value) {
      console.log(`selected ${value}`)
      this.$emit('change', value)
      // 修改父组件传入的value
      this._value = value
    },
    handleBlur () {
      // console.log('blur')
      this.$emit('blur')
    },
    handleFocus () {
      // console.log('focus')
      this.$emit('focus')
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }

  }
}
</script>

<style>

</style>
